<template>
  <div class="container">
    <!-- modal for post delete -->
    <div class="box">
      <div class="columns is-multiline" v-if="gallery">
        <div class="column is-12">
          <div class="field">
            <label class="label">Gallery's title</label>
            <div class="control">
              <input type="text" class="input" placeholder="Title" v-model="gallery.title">
            </div>
          </div>
        </div>
        <div class="column is-12">
          <quill-editor v-model="gallery.description" :options="editorOptions">
          </quill-editor>
          <input type="file" id="getImage" style="display: none;" @change="uploadImage">
        </div>
        <div class="column is-12">
          <div class="field">
            <!--<label class="label">Featured image</label>-->
            <div class="control">
              <!--<img :src="featuredImage">-->
              <div class="file">
                <label class="file-label">
                  <input @change="uploadImages" class="file-input" type="file" name="resume" multiple accept=".jpg, .jpeg, .png" :disabled="uploading"/>
                  <span class="file-cta">
                  <span class="file-icon">
                    <i class="fa fa-upload"></i>
                  </span>
                  <span class="file-label">
                    Choose a file…
                  </span>
                </span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-12" v-if="uploading">
          <progress class="progress is-primary" :value="progress" max="100"></progress>
        </div>
        <div class="column is-12">
          <GalleryImages :media="media" :gallery="gallery"></GalleryImages>
        </div>
      </div>

      <!-- the form buttons -->
      <button type="submit" class="button is-success" @click="updateGallery('published')">Update & Publish</button>
      <button type="submit" class="button is-info" @click="updateGallery('saved')">Update & Draft</button>
      <router-link to="/admin/galleries" class="button is-danger">Cancel</router-link>

      <!-- notification -->
      <transition mode="out-in" name="fade">
        <div v-if="notification.message" :class="'notification is-' + notification.type">
          <button class="delete" @click="hideNotifications"></button>{{notification.message}}
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import { mediaRef, galleriesRef } from '@/firebase_config'
import notifier from '@/mixins/notifier'
import editorOptions from './editor-options'
import imageLoader from '@/mixins/image-loader'

import GalleryImages from './GalleryImages'

export default {
  name: 'user-gallery-edit',
  data () {
    return {
      showModal: false,
      currentUser: firebase.auth().currentUser,
      uploading: false,
      uploadingFilesCount: 0,
      uploadedFilesCount: 0,
      gallery: null,
      editorOptions
    }
  },
  firebase () {
    return {
      media: mediaRef
    }
  },
  mixins: [imageLoader, notifier],
  methods: {
    updateGallery (state) {
      this.gallery.state = state
      galleriesRef.child(this.$route.params.key).set(this.gallery).then(() => {
        if (this.gallery.state === 'saved') {
          this.showNotification('success', 'Gallery updated successfully')
        }
        if (this.gallery.state === 'published') {
          this.showNotification('success', 'Gallery updated and published successfully')
        }
      })
    },
    uploadImages (e) {
      let files = e.target.files
      this.uploading = true
      this.uploadedFilesCount = 0
      this.uploadingFilesCount = files.length

      for (let i = 0; i < files.length; i++) {
        let file = files[i]
        this.uploadImage(file)
      }
    },
    uploadImage (file) {
      let storageRef = firebase.storage().ref('images/' + file.name)
      let uploadTask = storageRef.put(file)

      uploadTask.then(this.addImageToMedia)
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, this.handleUploadProgress, this.handleUploadError, this.handleUploadComplete)// .then(this.addImageToMedia)
    },
    handleUploadProgress (snapshot) {
      switch (snapshot.state) {
        case firebase.storage.TaskState.PAUSED: // or 'paused'
          console.log('Upload is paused')
          break
        case firebase.storage.TaskState.RUNNING: // or 'running'
          console.log('Upload is running')
          break
      }
    },
    handleUploadError (error) {
      switch (error.code) {
        case 'storage/unauthorized':
          console.log('storage/unauthorized')
          // User doesn't have permission to access the object
          break
        case 'storage/canceled':
          console.log('storage/canceled')
          // User canceled the upload
          break
        case 'storage/unknown':
          console.log('storage/unknown')
          // Unknown error occurred, inspect error.serverResponse
          break
        default:
          console.log(error)
      }
    },
    handleUploadComplete () {
      this.uploadedFilesCount++
    },
    addImageToMedia (snapshot) {
      this.showNotification('success', snapshot.metadata.name + ' uploaded.')

      let mediaObj = {
        src: snapshot.downloadURL,
        path: snapshot.ref.fullPath,
        name: snapshot.metadata.name,
        contentType: snapshot.metadata.contentType,
        createdBy: this.currentUser.uid,
        createdOn: (new Date()).toISOString()
      }
      mediaRef.push(mediaObj).then(
        media => {
          this.placeImageInGallery(media.key)
        }
      )
    },
    placeImageInGallery (key) {
      if (!this.gallery.hasOwnProperty('images')) {
        this.$set(this.$data.gallery, 'images', [])
      }
      this.gallery.images.push(key)
    },
    loadCurrent () {
      galleriesRef.child(this.$route.params.key).once('value', snapshot => {
        this.gallery = snapshot.val()
      })
    }
  },
  watch: {
    '$route' () {
      this.loadCurrent()
    },
    progress (val) {
      if (val === 100) {
        this.uploading = false
        this.uploadingFilesCount = 0
        this.uploadedFilesCount = 0
      }
    }
  },
  mounted () {
    this.loadCurrent()
  },
  computed: {
    progress () {
      return (this.uploadedFilesCount / this.uploadingFilesCount) * 100
    }
  },
  components: {
    GalleryImages
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/content/GalleriesEdit.vue